import { useQuery } from '@apollo/client';
import React from 'react';
import {
  Product,
  ProductElement,
  ProductGroup,
  RETRIEVE_QUOTATION,
} from '../graphql';
import { Quotation, QuotationFactor } from '../graphql/types';

/**
 * Similar to `usePrevious` to preserve the previous value during re-render, but
 * skipping `null` or `undefined`
 * https://github.com/apollographql/apollo-client/issues/6039#issuecomment-657703849
 * @param value - the value to be track and preserve
 * @returns the previous non-nullish `value` before re-render
 */
export const usePreviousNonNullish = <T>(value: T): T => {
  const ref = React.useRef<T>(value);
  React.useEffect(() => {
    if (value !== null && value !== undefined) {
      ref.current = value;
    }
  });
  return ref.current;
};

export const useQuotation = ({
  productId,
  age,
  gender,
  smoker,
  sumAssured,
  couponCode,
}: QuotationFactor) => {
  const { data, ...payload } = useQuery<{ quotation: Quotation }>(
    RETRIEVE_QUOTATION,
    {
      variables: {
        productId,
        age,
        gender,
        smoker,
        sumAssured,
        couponCode,
      },
      skip: !productId,
    },
  );

  return [data?.quotation, payload] as const;
};

export const getProductList = (productGroups: ProductGroup[]) => {
  let productList: Product[] = [];
  productGroups.forEach((productGroup: ProductGroup) => {
    productGroup.elements.forEach((element: ProductElement) => {
      productList = [element.resource, ...productList];
    });
  });
  return productList;
};

export const getProductListAttributes = (productGroups: ProductGroup[]) => {
  return productGroups[0].variables;
};
